import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401/403 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // If token is invalid or expired, clear it
    if (error.response?.status === 401) {
      console.error('Token invalid or expired, clearing...');
      localStorage.removeItem('token');
      // Only redirect if not already on login/public pages
      const publicPaths = ['/login', '/creator-enquiry', '/creator/'];
      const isPublicPath = publicPaths.some(p => window.location.pathname.includes(p) || window.location.pathname === '/');
      if (!isPublicPath) {
        window.location.href = '/login';
      }
    }
    // For 403 (Forbidden), the user is authenticated but not authorized.
    // Do NOT modify the response data — the real error message from the backend
    // (e.g. "Admin access required" or "Superadmin access required") is useful for debugging.
    if (error.response?.status === 403) {
      console.error('Access forbidden:', error.response?.data?.detail || 'permission denied');
    }
    return Promise.reject(error);
  }
);

export default api;